
define('eteration/widgets/ui-cms-smarttarget',[ 'knockout','eteration/eteration-ajax','eteration/eteration-i18n','ui-helper/cookie-helper'], function(ko,etrAjax,i18n,cookieHelper) {

    ko.bindingHandlers.cmsst = {
    	    update: function(element, valueAccessor, allBindingsAccessor, viewModel) {    	    
    	    		getContent(element, valueAccessor, allBindingsAccessor, viewModel);
      	    }
    };
	
    
    
    function getContent(element, valueAccessor, allBindingsAccessor, viewModel){
    	
    	var maxItems = ko.unwrap(valueAccessor().maxItems);
	       var region = ko.unwrap(valueAccessor().region);
	       var template = ko.unwrap(valueAccessor().template);
	       var includeMetadata = ko.unwrap(valueAccessor().includeMetadata);
	       var keyword = ko.unwrap(valueAccessor().keyword);
	       var params = ko.unwrap(valueAccessor().params);
	       var callback = ko.unwrap(valueAccessor().callback);
			var language= i18n.getUserLocale();
			var country =i18n.getUserCountry();
	       var servicePath = '/content/stquery';

	       var pass = {
	    			'region': region,
	    			'maxItems': maxItems,
	    			'template': template,
	    			'keyword': keyword,
	    			'includeMetadata': includeMetadata,
					'language':language,
					'country':country
		           };
	    
    	var darkPage=false;
		if(cookieHelper&&cookieHelper.getCookie("DPage")&&(cookieHelper.getCookie("DPage")=="true"||cookieHelper.getCookie("DPage")==true)){
			darkPage=true;
			
    	}
    	
	       
	       
	  
	       
	        if(template){
	        	servicePath = '/content/stquerytmp';
	        }
	        else {
	        	delete pass.template;
	        }
	        
	        var getFallback = function (region) {
                if("Thank you - Miles and Smiles Signup"==region){
                    return { "schema":"Teaser", "maxItems": 1,    "template":"Thank You Miles and Smiles Signup Large Block",   "keyword":[  {"Application Metadata":"MS.Unlogged.SignupLargeBlock" } ], "includeMetadata": true};
                }
                if("Thank you - Proposed Tour"==region){
                    return {"schema":"Destination Header Slider", "maxItems": 1, "template":"Proposed Detour", "keyword":[{}],"includeMetadata": true};
                }
            }

	        var addFallback = function (param) {
			    var pdata = getFallback(param.region)

                if(pdata!=null){
					param['fallback'] = pdata;
				}
            }

            addFallback(pass);

	    	var saveAPIInfo = {
					app : 'app.cms',
					service : servicePath,
					disableLoader:true,
					disableErrorHandling:true,
	    			data: pass,
	    			darkPageActive:darkPage,
	    			global:false,
	    			callback:function(response) {
						 if(response.data){
							 
							 var mydiv =  $(element);
							 var allHTML = "";
				               if(mydiv){
				            	   mydiv.html("");
				                   var tridionContent = "";
				                   tridionContent = response.data.components || [];
				                   for(var i=0; i < tridionContent.length; i++){
				                	   allHTML += tridionContent[i].html
				                   }
				                   
				                   if(params){
				                	    for(var i=0; i < params.length; i++){
				                	   		var param = params[i];
				                	   		allHTML = allHTML.replace('{.'+param.key+'}',param.value);
				                   		}
				                   }
				                   mydiv.html(allHTML); 
				                   if(callback){
				                	   callback();
				                   }
				               }    	
														 
						 }else{
							 $(element).html("");
							 console.info("NO CONTENT FOUND");
						 }
					},
		    		darkPageAlternativeService : function() {
		    			console.info("getting alternative content for dpage for region "+region);    	 


		    			var pdata = getFallback(region);

		    			if(!pdata){
		    				return;
						}

		    			console.info("new query: "+pdata);    
		    			
						etrAjax.post({
							app: 'app.cms',
		    	    		service:'/content/query',
		    	    		disableErrorHandling:true,
		    	    		forceExecuteDarkPageService:true,
		    	    		global:false,
		    	    		disableLoader:true,
		    	    		data: pdata,
							callback : function(response) {
								 if(response.data){
									 
									 var mydiv =  $(element);
									 var allHTML = "";
						               if(mydiv){
						            	   mydiv.html("");
						                   var tridionContent = "";
						                   tridionContent = response.data.components || [];
						                   for(var i=0; i < tridionContent.length; i++){
						                	   allHTML += tridionContent[i].html
						                   }
						                   
						                   if(params){
						                	    for(var i=0; i < params.length; i++){
						                	   		var param = params[i];
						                	   		allHTML = allHTML.replace('{.'+param.key+'}',param.value);
						                   		}
						                   }
						                   mydiv.html(allHTML); 
						                   if(callback){
						                	   callback();
						                   }
						               }    	
																 
								 }else{
									 $(element).html("NO CONTENT DUE TO ERROR");
								 }
							}
						});
					}
	    	};
	    	
	    	etrAjax.post(saveAPIInfo);
	    		      
    }
	
});